import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnEmbedPicker } from './embed-picker';
import { CnTimePicker as UICnTimePicker, } from './time-picker';
import './styles/index.scss';
const CnTimePicker = withI18n(UICnTimePicker, {
    locale,
    _noHoc: true,
});
// @ts-ignore
const CnTimePickerPro = CnTimePicker;
CnTimePicker.displayName = 'CnTimePickerPro';
CnTimePickerPro.CnEmbedPicker = CnTimePicker;
export { CnEmbedPicker, CnTimePickerPro, CnTimePicker };
